(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7058,65250],{

/***/ 7058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DebtReliefOasisWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/debtreliefoasis/logo/index.tsx


function DebtReliefOasisLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "342",
        height: "48",
        fill: "none",
        viewBox: "0 0 342 48",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_21)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1B6656",
                        d: "M67.806 37.121H58.31V12.4h9.7c3.737 0 6.655 1.115 8.76 3.345 2.122 2.23 3.19 5.253 3.19 9.067s-1.087 6.81-3.254 8.997c-2.149 2.204-5.111 3.313-8.893 3.313h-.007zm-4.532-19.97v15.218h4.767c2.124 0 3.783-.722 4.965-2.173 1.189-1.45 1.78-3.275 1.78-5.487 0-2.21-.591-3.934-1.78-5.385-1.189-1.45-2.841-2.173-4.965-2.173h-4.767zM101.299 27.586c0 .557-.057 1.248-.165 2.072H87.41c.674 2.585 2.448 3.877 5.34 3.877 2.123 0 4.093-.614 5.905-1.837l1.882 3.313c-2.327 1.673-4.99 2.51-7.99 2.51-3.198 0-5.664-.926-7.387-2.776-1.704-1.83-2.55-4.08-2.55-6.76 0-2.68.885-5.075 2.652-6.855 1.767-1.806 4.061-2.712 6.877-2.712 2.664 0 4.857.824 6.58 2.477 1.722 1.648 2.587 3.878 2.587 6.69h-.007zm-9.16-5.252c-1.188 0-2.199.342-3.038 1.02-.84.678-1.405 1.609-1.697 2.794h9.3c-.223-1.185-.738-2.11-1.545-2.794-.807-.678-1.812-1.02-3.02-1.02zM114.858 18.424c2.594 0 4.768.925 6.509 2.776 1.748 1.83 2.619 4.105 2.619 6.823s-.871 4.993-2.619 6.824c-1.748 1.806-3.915 2.712-6.509 2.712-2.307 0-4.208-.906-5.708-2.712v2.274h-4.596V11.696h4.729v9.3c1.52-1.716 3.376-2.578 5.569-2.578l.006.006zm-5.772 9.567c0 1.451.471 2.7 1.411 3.745.941 1.001 2.149 1.508 3.624 1.508s2.682-.5 3.623-1.508c.941-1.027 1.411-2.275 1.411-3.745 0-1.47-.47-2.711-1.411-3.712-.941-1.001-2.148-1.508-3.623-1.508s-2.683.513-3.624 1.54c-.94 1-1.411 2.23-1.411 3.68zM138.823 32.338l1.411 3.712c-1.519 1.002-3.325 1.508-5.403 1.508-2.079 0-3.694-.608-4.768-1.824-1.074-1.217-1.608-3.003-1.608-5.367V22.84h-2.988v-3.947h3.02v-6.456h4.697v6.456h6.039v3.947h-6.039v7.223c0 2.142.858 3.212 2.587 3.212.941 0 1.958-.31 3.052-.937zM168.991 37.121h-5.803l-5.238-8.997h-2.956v8.997h-4.965V12.4h9.497c2.753 0 4.857.76 6.312 2.275 1.456 1.514 2.181 3.37 2.181 5.55 0 1.653-.433 3.13-1.291 4.435-.864 1.305-2.11 2.249-3.744 2.826l6.007 9.636zm-9.497-20.135h-4.5v6.69h4.062c1.252 0 2.212-.31 2.867-.937.661-.621.991-1.438.991-2.44 0-1-.305-1.748-.921-2.375-.617-.621-1.45-.938-2.499-.938zM189.231 27.586c0 .557-.057 1.248-.165 2.072h-13.724c.673 2.585 2.447 3.877 5.333 3.877 2.123 0 4.093-.614 5.905-1.837l1.882 3.313c-2.327 1.673-4.99 2.51-7.991 2.51-3.197 0-5.663-.926-7.386-2.776-1.704-1.83-2.549-4.08-2.549-6.76 0-2.68.884-5.075 2.651-6.855 1.767-1.806 4.062-2.712 6.878-2.712 2.663 0 4.856.824 6.579 2.477 1.722 1.648 2.587 3.878 2.587 6.69zm-9.16-5.252c-1.189 0-2.199.342-3.039 1.02-.839.678-1.404 1.609-1.697 2.794h9.294c-.223-1.185-.738-2.11-1.545-2.794-.807-.678-1.812-1.02-3.019-1.02h.006zM197.215 11.696V37.12h-4.73V11.696h4.73zM206.851 13.939c0 .823-.279 1.514-.839 2.072-.559.557-1.252.836-2.078.836-.827 0-1.52-.279-2.079-.837-.559-.557-.839-1.248-.839-2.071 0-.824.28-1.508.839-2.04.559-.558 1.252-.837 2.079-.837.826 0 1.519.279 2.078.837.56.532.839 1.216.839 2.04zm-.572 4.948v18.228h-4.735V18.887h4.735zM228.261 27.586c0 .557-.058 1.248-.166 2.072h-13.724c.674 2.585 2.448 3.877 5.334 3.877 2.123 0 4.093-.614 5.905-1.837l1.881 3.313c-2.326 1.673-4.989 2.51-7.99 2.51-3.197 0-5.664-.926-7.386-2.776-1.697-1.83-2.549-4.08-2.549-6.76 0-2.68.883-5.075 2.65-6.855 1.768-1.806 4.062-2.712 6.878-2.712 2.664 0 4.857.824 6.579 2.477 1.723 1.648 2.588 3.878 2.588 6.69zm-9.16-5.252c-1.189 0-2.2.342-3.039 1.02-.839.678-1.405 1.609-1.697 2.794h9.293c-.222-1.185-.737-2.11-1.544-2.794-.808-.678-1.812-1.02-3.02-1.02h.007zM240.98 15.08c-1.093 0-1.932.271-2.517.816-.585.545-.871 1.33-.871 2.357v.634h5.67v3.947h-5.67v14.281h-4.736v-14.28h-2.816v-3.948h2.816v-.735c0-2.363.681-4.156 2.047-5.386 1.386-1.248 3.179-1.875 5.372-1.875 1.811 0 3.547.444 5.199 1.337l-1.544 3.611c-1.164-.513-2.149-.766-2.956-.766l.006.006zM263.839 37.52c-3.693 0-6.757-1.216-9.198-3.649-2.46-2.452-3.694-5.461-3.694-9.035 0-3.573 1.24-6.633 3.725-9.13 2.505-2.496 5.569-3.744 9.198-3.744 3.63 0 6.681 1.248 9.16 3.744 2.505 2.497 3.757 5.519 3.757 9.067s-1.252 6.557-3.757 9.035c-2.485 2.477-5.549 3.712-9.198 3.712h.007zm7.787-12.747c0-2.275-.75-4.156-2.251-5.652-1.5-1.495-3.356-2.274-5.505-2.274-2.148 0-3.985.76-5.504 2.274-1.52 1.515-2.251 3.377-2.251 5.652 0 2.274.738 4.125 2.213 5.62 1.5 1.495 3.343 2.243 5.536 2.243 2.193 0 4.037-.748 5.537-2.243 1.5-1.495 2.237-3.365 2.218-5.62h.007zM294.179 21.066v-2.173h4.5v18.228h-4.5v-2.11c-1.564 1.698-3.515 2.541-5.842 2.541-2.638 0-4.812-.912-6.509-2.743s-2.549-4.125-2.549-6.894c0-2.768.858-5.005 2.587-6.792 1.723-1.805 3.884-2.711 6.478-2.711 2.282 0 4.227.88 5.841 2.642l-.006.012zm.07 6.925c0-1.425-.49-2.667-1.475-3.712-.96-1.027-2.18-1.54-3.661-1.54-1.481 0-2.727.513-3.693 1.54-.941 1.026-1.412 2.261-1.412 3.712s.483 2.718 1.443 3.745c.96 1.026 2.181 1.54 3.655 1.54 1.475 0 2.696-.514 3.662-1.54.985-1.046 1.475-2.294 1.475-3.745h.006zM309.047 37.59c-3.178 0-5.695-1.172-7.552-3.51l2.518-2.978a7.21 7.21 0 002.333 1.857c.909.456 1.818.684 2.733.684.718 0 1.316-.165 1.799-.5.483-.336.718-.76.718-1.274 0-.646-.438-1.172-1.309-1.571a80.859 80.859 0 00-2.181-.837c-1.048-.38-1.837-.703-2.352-.97-2.104-1-3.152-2.578-3.152-4.713 0-1.584.622-2.902 1.881-3.947 1.233-1.026 2.886-1.54 4.965-1.54 2.593 0 4.729.868 6.407 2.61l-2.352 3.042c-1.278-1.204-2.676-1.806-4.195-1.806-.604 0-1.1.152-1.494.45-.394.304-.585.665-.585 1.09 0 .76.534 1.317 1.608 1.672 2.397.894 3.859 1.483 4.399 1.774 2.06 1.071 3.09 2.61 3.09 4.62 0 1.716-.674 3.123-2.016 4.213-1.296 1.096-3.051 1.64-5.269 1.64l.006-.006zM324.952 13.939c0 .823-.28 1.514-.84 2.072-.559.557-1.252.836-2.078.836-.827 0-1.519-.279-2.079-.837-.559-.557-.839-1.248-.839-2.071 0-.824.28-1.508.839-2.04.56-.558 1.252-.837 2.079-.837.826 0 1.519.279 2.078.837.56.532.84 1.216.84 2.04zm-.573 4.948v18.228h-4.735V18.887h4.735zM334.722 37.59c-3.179 0-5.696-1.172-7.552-3.51l2.517-2.978c.649.78 1.424 1.4 2.333 1.857.909.456 1.818.684 2.733.684.719 0 1.316-.165 1.799-.5.483-.336.719-.76.719-1.274 0-.646-.439-1.172-1.31-1.571a81.644 81.644 0 00-2.18-.837c-1.049-.38-1.837-.703-2.352-.97-2.104-1-3.153-2.578-3.153-4.713 0-1.584.623-2.902 1.882-3.947 1.233-1.026 2.885-1.54 4.964-1.54 2.594 0 4.729.868 6.408 2.61l-2.352 3.042c-1.278-1.204-2.677-1.806-4.196-1.806-.604 0-1.099.152-1.494.45-.394.304-.584.665-.584 1.09 0 .76.534 1.317 1.608 1.672 2.396.894 3.858 1.483 4.399 1.774 2.059 1.071 3.089 2.61 3.089 4.62 0 1.716-.674 3.123-2.015 4.213-1.297 1.096-3.051 1.64-5.27 1.64l.007-.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#6CBCAC",
                        d: "M39.615 24c0-7.99-5.34-13.99-11.252-13.99-.565 0-1.093.039-1.652.153C30.696 13.052 33.22 18.298 33.22 24c0 9.073-6.172 16.163-13.432 16.163-7.94 0-13.431-7.838-13.431-16.163.038-6.152 2.218-12.26 6.096-16.765C15.84 3.301 20.2.824 25.02.038c0 0-.413-.038-.941-.038C10.799 0 0 10.764 0 24c0 5.436 1.805 10.46 4.888 14.477 3.649 4.65 8.995 7.578 14.9 7.578 11.436.038 19.827-10.575 19.827-22.049V24z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1B6656",
                        d: "M43.263 9.523c-3.648-4.65-8.994-7.61-14.9-7.61C16.928 1.913 8.537 12.526 8.537 24c0 7.99 5.34 13.99 11.251 13.99.566 0 1.094-.039 1.653-.153-3.986-2.889-6.51-8.135-6.51-13.837 0-9.073 6.173-16.163 13.432-16.163 7.94 0 13.432 7.838 13.432 16.163-.038 6.152-2.219 12.26-6.096 16.764-3.388 3.935-7.749 6.412-12.567 7.198 0 0 .413.038.94.038 13.28 0 24.08-10.765 24.08-24 0-5.436-1.806-10.46-4.889-14.477z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1_21",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H342V48H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (DebtReliefOasisLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/debtReliefOasisWrapper.tsx








const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function DebtReliefOasisWrapper({ children , boxShadow  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Debt Relief",
                    domain: "DebtReliefOasis.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Debt Relief",
                    domain: "DebtReliefOasis.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "Find the Right debt relief For You",
                        boxShadow: boxShadow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ })

}]);